module.exports = __webpack_public_path__ + "img/sharemail.22efba2c.svg";